<template>
  <div v-if="visualType === 'division-error'" class="solution-block">
    <p class="solution-block__lead">
      다음 풀이에서 오류가 있는<br />
      부분을 선택하세요.
    </p>

    <div class="solution-row">
      <strong>11 ÷ 1.2</strong>
    </div>

    <div class="solution-row solution-row--tagged">
      <strong>= 11 ÷ (1 + 0.2)</strong>
      <span>A</span>
    </div>

    <div class="solution-row solution-row--tagged">
      <strong>= (11 ÷ 1) + (11 ÷ 0.2)</strong>
      <span>B</span>
    </div>

    <div class="solution-row solution-row--tagged">
      <strong>= 11 + 55 = 66</strong>
      <span>C</span>
    </div>
  </div>

  <div v-else-if="visualType === 'operation-order-error'" class="solution-block">
    <p class="solution-block__lead">
      다음 풀이에서 오류가 있는<br />
      부분을 선택하세요.
    </p>

    <div class="solution-row solution-row--tagged">
      <strong>나눗셈 먼저, (3 ÷ 1/3)</strong>
      <span>A</span>
    </div>

    <div class="solution-row solution-row--tagged">
      <strong>9 − (3 ÷ 1/3) + 1 = 9 − 1 + 1</strong>
      <span>B</span>
    </div>

    <div class="solution-row solution-row--tagged">
      <strong>= 9 − 1 + 1 = 9</strong>
      <span>C</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { VisualType } from '@/types/content'

defineProps<{
  visualType?: VisualType
}>()
</script>